<template>
    <v-autocomplete
        @update:search-input="SearchProductoCompra"
        v-model="id_producto_compra"
        :items="productos_compra"
        item-text="titulo"
        item-value="id"
        :label="label"
        :outlined="outlined"
    >
        <template v-slot:append-item>
            <div v-intersect="endIntersect" />
        </template>
    </v-autocomplete>
</template>
<script>
import { debounce } from "../../helpers";

export default {
    props: ["value", "extra", "label", "item-text", "enabled", "outlined"],
    data() {
        return {
            creado: null,

            id_producto_compra: null,
            producto_compra: {},
            dialog: false,
            users: [],
            update: false,
        };
    },
    watch: {
        value(val) {
            this.id_producto_compra = val;
        },
        id_producto_compra(val) {
            this.$emit("input", val);
        },
    },
    methods: {
        getAgente() {
            axios.post(`api/getselectagente`, this.filters).then(
                (res) => {
                    this.users = res.data;
                },
                (res) => {
                    this.$toast.error("Error al obtener los agentes");
                }
            );
        },
        SearchProductoCompra: debounce(function (val) {
            this.$store.dispatch("searchProductosCompra", val);
        }, 500),
        endIntersect(entries, observer, isIntersecting) {
            if (isIntersecting) {
                this.$store.dispatch("getProductosCompraNext", this);
            }
        },
    },
    mounted() {
        this.$store.dispatch("getProductosCompra", this);
        if (this.value != null) {
            this.id_producto_compra = this.value;
        }
        // this.getAgente();
    },
    computed: {
        productos_compra() {
            ///console.log("siva");
            let productos_compra_temp = this.$store.getters.getproductos_compra;
            if (this.extra?.nombre != null) {
                productos_compra_temp.push(this.extra);
            }
            if (this.creado) {
                productos_compra_temp.push(this.creado);
            }
            console.log(productos_compra_temp);
            return productos_compra_temp;
        },
    },
};
</script>
